// axios
import axios from "axios";
import { fileURL, fileWithProgress, discordApi } from "./productionStatus";

// Axios örneği oluşturma
const fileAx = axios.create({
  baseURL: fileURL,
});
fileAx.interceptors.request.use(
  (config) => {
    // Token bilgisi global olarak ekleniyor
    const token = localStorage.getItem("UserToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    // Hata durumunda işlem
    return Promise.reject(error);
  }
);

const fileAxWP = axios.create({
  baseURL: fileWithProgress,
});
fileAxWP.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("UserToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const discAx = axios.create({
  baseURL: discordApi,
});

discAx.interceptors.request.use(
  (config) => {
    // Token bilgisi global olarak ekleniyor
    const token = localStorage.getItem("UserToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    // Hata durumunda işlem
    return Promise.reject(error);
  }
);

export { fileAx, fileAxWP, discAx };
